// import Vue from "vue";
import { createRouter, createWebHistory } from 'vue-router';
import { isMenuClosed, isClosureExempt } from './config/menuClosure';
import { CHILD_TO_PARENT } from './utils/pagePermission';
import Login from './views/Login.vue';
import UserManagement from './views/UserManagement.vue';
import UserProfile from './views/UserProfile.vue';
import MenuManagement from './views/MenuManagement.vue';
import Calendar from './views/Calendar.vue';
import Permission from './views/Permission.vue';
import Log from './views/Log.vue';
import Setting from './views/Setting.vue';
import LogAPIExternal from './views/LogAPIExternal.vue';
import SocialApiLog from './views/SocialApiLog.vue';
import JobLog from './views/JobLog.vue';
// import UserGroup from "./views/UserGroup";
import GPTModelManagement from './views/GPTModelManagement.vue';
import GPTModelDetail from './views/GPTModelDetail.vue';
import FlowList from './views/FlowList.vue';
import FlowCreator from './views/Flow.vue';
import FlowCompare from './views/FlowCompare.vue';
import ToolManagement from './views/ToolManagement.vue';
import DocumentGroupManagement from './views/DocumentGroupManagement.vue';
import ProductGroupManagement from './views/ProductGroupManagement.vue';
import Setup from './views/Setup.vue';
import GPTModelNodeManagement from './views/GPTModelNodeManagement.vue';
import GPTModelNodeDetail from './views/GPTModelNodeDetail.vue';
import GroupReplacetext from './views/GroupReplacetext.vue';
import ReplaceText from './views/ReplaceText.vue';
import UploadCSV from './views/UploadCSV.vue';
import MetaDoc from './views/MetaDoc.vue';
import UploadVector from './views/UploadVector.vue';
import DocumentControl from './views/DocumentControl.vue';
import CommunityManagement from './views/CommunityManagement.vue';
import CommunityGraph from './views/CommunityGraph.vue';
import MetaCommunityManagement from './views/MetaCommunityManagement.vue';
import MetaCommunityGraph from './views/MetaCommunityGraph.vue';
import GenerationErrorLogs from './views/GenerationErrorLogs.vue';
import UploadSoundToDocument from './views/UploadSoundToDocument.vue';
import UploadSoundToDocumentDetail from './views/UploadSoundToDocumentDetail.vue';
import DataIntegration from './views/DataIntegration.vue';
import DataIntegrationDetail from './views/DataIntegrationDetail.vue';
import MutualFund from './views/MutualFund.vue';
import MutualFundDetail from './views/MutualFundDetail.vue';
import ModelAndVectorManagement from './views/ModelAndVectorManagement.vue';
import Dashboard from './views/Dashboard.vue';
import ValidationGenerate from './views/ValidationGenerate.vue';
import ValidationGenerateUpload from './views/ValidationGenerateUpload.vue';
import ValidationProcess from './views/ValidationProcess.vue';
import ValidationPositive from './views/ValidationPositive.vue';
import ValidationNegative from './views/ValidationNegative.vue';
import ValidationPositiveDetail from './views/ValidationPositiveDetail.vue';
import ValidationNegativeDetail from './views/ValidationNegativeDetail.vue';

import LogMessage from './views/LogMessage.vue';
import ContactAgentChatLog from './views/ContactAgentChatLog.vue';
import LogEvent from './views/LogEvent.vue';
import Stream from './views/Stream.vue';
import GroupPromptTemplate from './views/GroupPromptTemplate.vue';
// import FullStream from "./views/FullStream";
import FullStreamReDesign from './views/FullStreamReDesign.vue';
import DashboardScore from './views/DashboardScore.vue';
import SetupSocial from './views/SetupSocial.vue';
import SetupGroupModel from './views/SetupGroupModel.vue';
import UserChatManagement from './views/UserChatManagement.vue';
import ChatService from './views/ChatService.vue';

import Cookies from 'js-cookie';
import ModelData from './views/ModelData.vue';
import AccessDenied from './views/AccessDenied.vue';
import ErrorPage from './views/ErrorPage.vue';

// import ModelQuick from './views/ModelQuick';

import ModelQuickGroup from './views/ModelQuickGroup.vue';
import ModelQuickReply from './views/ModelQuickReply.vue';
import SettingExternalConnector from './views/SettingExternalConnector.vue';
import McpConnection from './views/McpConnection.vue';
import PlayGround from './views/PlayGround.vue';
import CSharpPlayground from './views/CSharpPlayground.vue';
import ServiceTheme from './views/ConfigTheme.vue';
import ConsentConfig from './views/ConsentConfig.vue';

//Report
import ReportQuestionTop10 from './views/ReportQuestionTop10.vue';
import ReportUserTop10 from './views/ReportUserTop10.vue';
import ReportUserUse from './views/ReportUserUse.vue';
import ReportFeedback from './views/ReportFeedback.vue';

import PromptTemplate from './views/PromptTemplate.vue';
import Release from './views/Release-notes.vue';
import IntentGroup from './views/IntentGroup.vue';
import IntentSession from './views/IntentSession.vue';
import IntentSessionDetail from './views/IntentSessionDetail.vue';
import AccountInfoManagement from './views/AccountInfoManagement.vue';
import LoanInterestRate from './views/LoanInterestRate.vue';
import STTLogs from './views/STTLogs.vue';
import GPTLogs from './views/GPTLogs.vue';
import TTSLogs from './views/TTSLogs.vue';
import ChatFullLogs from './views/ChatFullLogs.vue';
import CifZeroInitLog from './views/CifZeroInitLog.vue';

import LoginSnippet from './views/Snippet/LoginSnippet.vue';
import Snippet from './views/Snippet/Snippet.vue';
import RedirectFromLogin from './views/RedirectFromLogin.vue';
import ReportTokenSum from './views/ReportTokenSum.vue';
import GroupUserManagement from './views/GroupUserManagement.vue';
import UserGroupDetail from './views/UserGroupDetail.vue';
import SetupUserGroup from './views/SetupUserGroup.vue';
import BlacklistChatUserManagement from './views/BlacklistChatUserManagement.vue';
import FileManagements from './views/FileManagement.vue';
import ShortcutMenu from './views/ShortcutMenu.vue';
import ProductGroup from './views/ProductGroup.vue';
import ProductDetail from './views/ProductDetail.vue';
import ProactiveMessage from './views/ProactiveMessage.vue';
import BarManagement from './views/BarManagement.vue';
import DeepLinkConfig from './views/DeepLinkConfig.vue';
import SystemConfiguration from './views/SystemConfiguration.vue';
import MobileConfigurations from './views/MobileConfigurations.vue';
import TaxPlanningMobileConfigurations from './views/TaxPlanningMobileConfigurations.vue';
import LHBDashboard from './views/LHBDashboard.vue';
import LexiconManagement from './views/LexiconManagement.vue';
import TargetPhraseManagement from './views/TargetPhraseManagement.vue';
import VoiceConfigs from './views/VoiceConfigs.vue';
import VoiceConfigDetail from './views/VoiceConfigDetail.vue';
import ValidationJobDetail from './views/ValidationJobDetail.vue';
import ValidationJobDetailV2 from './views/ValidationJobDetailV2.vue';
import ValidationMasterDataV2 from './views/ValidationMasterDataV2.vue';
import ValidationTestRunnerV2 from './views/ValidationTestRunnerV2.vue';
import ValidationDashboardV2 from './views/ValidationDashboardV2.vue';

import TaxCategory from './views/TaxCategory.vue';
import TaxConfiguration from './views/TaxConfiguration.vue';
import TaxConfigurationEdit from './views/TaxConfigurationEdit.vue';
import TaxConfigurationV2 from './views/TaxConfigurationV2.vue';
import TaxConfigurationV2Edit from './views/TaxConfigurationV2Edit.vue';
import TaxQuestionV2Edit from './views/TaxQuestionV2Edit.vue';
import TaxPlaygroundV2 from './views/TaxPlaygroundV2.vue';
// Tax Log V2 is the READ-ONLY viewer of Tax Planning V2 chat sessions (list → session detail).
import TaxLogV2 from './views/TaxLogV2.vue';
import TaxLogV2Detail from './views/TaxLogV2Detail.vue';
// Tax Chat Log = หน้า Chat Logs ในโหมดภาษี (ตัว wrapper ของ LogMessage.vue)
import TaxChatLog from './views/TaxChatLog.vue';
import TaxQuestionEdit from './views/TaxQuestionEdit.vue';
// Tax Calculate is a two-level editor: TaxCalculateList (the version's formula list) → TaxFormulaBlockly
// (the Blockly canvas of ONE formula).
import TaxCalculateList from './views/TaxCalculateList.vue';
import TaxFormulaBlockly from './views/TaxFormulaBlockly.vue';
// Tax Calculate V2 is a two-level editor reached by drilling into the Tax Configuration V2 tree:
// TaxCalculateV2List (one calc version's C# functions) → TaxCalcFunctionV2Edit (the C# code editor
// of ONE function). The calc-version list itself lives inside TaxConfigurationV2, not as its own route.
import TaxCalculateV2List from './views/TaxCalculateV2List.vue';
import TaxCalcFunctionV2Edit from './views/TaxCalcFunctionV2Edit.vue';
import TaxSandbox from './views/TaxSandbox.vue';
import TaxHistory from './views/TaxHistory.vue';
import TaxHistoryDetail from './views/TaxHistoryDetail.vue';
import TaxHistoryV2 from './views/TaxHistoryV2.vue';
import TaxHistoryV2Detail from './views/TaxHistoryV2Detail.vue';
import TaxFeedbackSettings from './views/TaxFeedbackSettings.vue';
import TaxDashboard from './views/TaxDashboard.vue';
import TaxConsent from './views/TaxConsent.vue';
import TaxConsentEdit from './views/TaxConsentEdit.vue';
import DecryptTax from './views/DecryptTax.vue';

// Vue.use(Router);
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), // ใช้ createWebHistory แทน mode: "history"
  base: import.meta.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Login',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/RedirectFromLogin',
      name: 'RedirectFromLogin',
      component: RedirectFromLogin,
    },
    {
      path: '/LoginSnippet',
      name: 'LoginSnippet',
      component: LoginSnippet,
    },
    {
      path: '/Snippet',
      name: 'Snippet',
      component: Snippet,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/Usermanagement',
      name: 'UserManagement',
      component: UserManagement,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/userprofile',
      name: 'UserProfile',
      component: UserProfile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/menumanagement',
      name: 'MenuManagement',
      component: MenuManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/permission',
      name: 'Permission',
      component: Permission,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/log',
      name: 'Log',
      component: Log,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    // {
    //   path: "/usergroup",
    //   name: "UserGroup",
    //   component: UserGroup,
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: '/GroupReplacetext',
      name: 'GroupReplacetext',
      component: GroupReplacetext,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ReplaceText',
      name: 'ReplaceText',
      component: ReplaceText,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/FlowList',
      name: 'FlowList',
      component: FlowList,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/FlowCreator',
      name: 'FlowCreator',
      component: FlowCreator,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/FlowCompare',
      name: 'FlowCompare',
      component: FlowCompare,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ToolManagement',
      name: 'ToolManagement',
      component: ToolManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/DocumentGroupManagement',
      name: 'DocumentGroupManagement',
      component: DocumentGroupManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ProductGroupManagement',
      name: 'ProductGroupManagement',
      component: ProductGroupManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/GroupPromptTemplate',
      name: 'GroupPromptTemplate',
      component: GroupPromptTemplate,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/GPTModelManagement',
      name: 'GPTModelManagement',
      component: GPTModelManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/AccountInfoManagement',
      name: 'AccountInfoManagement',
      component: AccountInfoManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/LoanInterestRate',
      name: 'LoanInterestRate',
      component: LoanInterestRate,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    // {
    //   path: '/STTLogs',
    //   name: 'STTLogs',
    //   component: STTLogs,
    //   meta: {
    //     requiresAuth: true,
    //     isProductAdmin: true,
    //   },
    // },
    {
      path: '/GPTLogs',
      name: 'GPTLogs',
      component: GPTLogs,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TTSLogs',
      name: 'TTSLogs',
      component: TTSLogs,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/GPTModelDetail',
      name: 'GPTModelDetail',
      component: GPTModelDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/GPTModelInternal',
      name: 'GPTModelNodeManagement',
      component: GPTModelNodeManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/GPTModelInternalDetail',
      name: 'GPTModelInternalDetail',
      component: GPTModelNodeDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/VectorManagement',
      name: 'VectorManagement',
      component: UploadCSV,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/metadoc',
      name: 'MetaDoc',
      component: MetaDoc,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/UploadVector',
      name: 'UploadVector',
      component: UploadVector,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/DocumentControl',
      name: 'DocumentControl',
      component: DocumentControl,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/CommunityManagement',
      name: 'CommunityManagement',
      component: CommunityManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/CommunityGraph/:id',
      name: 'CommunityGraph',
      component: CommunityGraph,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/MetaCommunityManagement',
      name: 'MetaCommunityManagement',
      component: MetaCommunityManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/GenerationErrorLogs',
      name: 'GenerationErrorLogs',
      component: GenerationErrorLogs,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/MetaCommunityGraph/:id',
      name: 'MetaCommunityGraph',
      component: MetaCommunityGraph,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/DataIntegration',
      name: 'DataIntegration',
      component: DataIntegration,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },

    {
      path: '/DataIntegrationDetail',
      name: 'DataIntegrationDetail',
      component: DataIntegrationDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/MutualFund',
      name: 'MutualFund',
      component: MutualFund,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/MutualFundDetail',
      name: 'MutualFundDetail',
      component: MutualFundDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ProductGroup',
      name: 'ProductGroup',
      component: ProductGroup,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ProductDetail',
      name: 'ProductDetail',
      component: ProductDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/IntentGroup',
      name: 'IntentGroup',
      component: IntentGroup,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },

    {
      path: '/IntentSession',
      name: 'IntentSession',
      component: IntentSession,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/IntentSessionDetail',
      name: 'IntentSessionDetail',
      component: IntentSessionDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },

    {
      path: '/ModelAndVectorManagement',
      name: 'ModelAndVectorManagement',
      component: ModelAndVectorManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/DashboardScore',
      name: 'DashboardScore',
      component: DashboardScore,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationGenerate',
      name: 'ValidationGenerate',
      component: ValidationGenerate,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationGenerateUpload',
      name: 'ValidationGenerateUpload',
      component: ValidationGenerateUpload,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationProcess',
      name: 'ValidationProcess',
      component: ValidationProcess,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationPositive',
      name: 'ValidationPositive',
      component: ValidationPositive,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationNegative',
      name: 'ValidationNegative',
      component: ValidationNegative,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationPositiveDetail',
      name: 'ValidationPositiveDetail',
      component: ValidationPositiveDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationNegativeDetail',
      name: 'ValidationNegativeDetail',
      component: ValidationNegativeDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/LogMessage',
      name: 'LogMessage',
      component: LogMessage,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ContactAgentChatLog',
      name: 'ContactAgentChatLog',
      component: ContactAgentChatLog,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/Stream',
      name: 'Stream',
      component: Stream,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    // {
    //   path: "/FullStream",
    //   name: "FullStream",
    //   component: FullStream,
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    {
      path: '/FullStream',
      name: 'FullStream',
      component: FullStreamReDesign,
      meta: {
        requiresAuth: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/setup',
      name: 'Setup',
      component: Setup,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      path: '/SetupSocial',
      name: 'SetupSocial',
      component: SetupSocial,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/SetupGroupModel',
      name: 'SetupGroupModel',
      component: SetupGroupModel,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/modeldata',
      name: 'ModelData',
      component: ModelData,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    // {
    //   path: "/ModelQuick",
    //   name: "ModelQuick",
    //   component: ModelQuick,
    // },

    {
      path: '/ModelShortcut',
      name: 'ModelShortcut',
      component: ModelQuickGroup,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ModelQuickReply',
      name: 'ModelQuickReply',
      component: ModelQuickReply,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/SettingExternalConnector',
      name: 'SettingExternalConnector',
      component: SettingExternalConnector,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      // โทเคนสำหรับต่อ remote MCP — 🔴 ด่านจริงไม่ได้อยู่ที่ meta ตรงนี้ แต่อยู่ที่การมีชื่อ route
      // ใน SuperAdminRights/adminRights ข้างล่าง (guard อ่านจากอาร์เรย์ ไม่ได้อ่าน meta)
      path: '/McpConnection',
      name: 'McpConnection',
      component: McpConnection,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/Playground',
      name: 'Playground',
      component: PlayGround,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/CSharpPlayground',
      name: 'CSharpPlayground',
      component: CSharpPlayground,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ServiceTheme',
      name: 'ServiceTheme',
      component: ServiceTheme,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      path: '/AccessDenied',
      name: 'AccessDenied',
      component: AccessDenied,
    },
    {
      path: '/UserChatManagement',
      name: 'UserChatManagement',
      component: UserChatManagement,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ChatService',
      name: 'ChatService',
      component: ChatService,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },

    {
      path: '/ReportQuestionTop10',
      name: 'ReportQuestionTop10',
      component: ReportQuestionTop10,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ReportUserTop10',
      name: 'ReportUserTop10',
      component: ReportUserTop10,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ReportUserUse',
      name: 'ReportUserUse',
      component: ReportUserUse,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/PromptTemplate',
      name: 'PromptTemplate',
      component: PromptTemplate,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/Release-notes',
      name: 'Release-notes',
      component: Release,
      meta: {
        requiresAuth: true,
        // isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ReportTokenSum',
      name: 'ReportTokenSum',
      component: ReportTokenSum,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },

    {
      path: '/LogEvent',
      name: 'LogEvent',
      component: LogEvent,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      path: '/LogAPIExternal',
      name: 'LogAPIExternal',
      component: LogAPIExternal,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      // L6 — log การรับส่งข้อมูลกับ MIAW/webhook · docs/Social-Api-Log-Plan.md
      // ⚠️ อยู่ใน SuperAdminRights เท่านั้น ไม่ใส่ adminRights — หน้านี้แสดงบทสนทนาลูกค้าจริง
      path: '/SocialApiLog',
      name: 'SocialApiLog',
      component: SocialApiLog,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      // Job Log — ดู/สั่งงาน Hangfire ของ process ที่ SPA คุยด้วย · tasks/2026-09-18-hangfire-job-log/TASK.md
      // ⚠️ อยู่ใน SuperAdminRights เท่านั้น ไม่ใส่ adminRights — หน้านี้สั่ง Requeue/Delete/Trigger งานได้
      path: '/JobLog',
      name: 'JobLog',
      component: JobLog,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      path: '/GroupUserManagement',
      name: 'GroupUserManagement',
      component: GroupUserManagement,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/UserGroupDetail',
      name: 'UserGroupDetail',
      component: UserGroupDetail,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/SetupUserGroup',
      name: 'SetupUserGroup',
      component: SetupUserGroup,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/UploadSoundToDocument',
      name: 'UploadSoundToDocument',
      component: UploadSoundToDocument,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/UploadSoundToDocumentDetail',
      name: 'UploadSoundToDocumentDetail',
      component: UploadSoundToDocumentDetail,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/BlacklistChatUserManagement',
      name: 'BlacklistChatUserManagement',
      component: BlacklistChatUserManagement,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ReportFeedback',
      name: 'ReportFeedback',
      component: ReportFeedback,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ConsentConfig',
      name: 'ConsentConfig',
      component: ConsentConfig,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      path: '/error/:code',
      name: 'error',
      component: ErrorPage,
      meta: {
        requiresAuth: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/error/404',
    },
    {
      path: '/FileManagements',
      name: 'FileManagements',
      component: FileManagements,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ShortcutMenu',
      name: 'ShortcutMenu',
      component: ShortcutMenu,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/ProactiveMessage',
      name: 'ProactiveMessage',
      component: ProactiveMessage,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: false,
      },
    },
    {
      path: '/BarManagement',
      name: 'BarManagement',
      component: BarManagement,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: false,
      },
    },
    {
      path: '/DeepLinkConfig',
      name: 'DeepLinkConfig',
      component: DeepLinkConfig,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/SystemConfiguration',
      name: 'SystemConfiguration',
      component: SystemConfiguration,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/MobileConfigurations',
      name: 'MobileConfigurations',
      component: MobileConfigurations,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxPlanningMobileConfigurations',
      name: 'TaxPlanningMobileConfigurations',
      component: TaxPlanningMobileConfigurations,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/LHBDashboard',
      name: 'LHBDashboard',
      component: LHBDashboard,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/LexiconManagement',
      name: 'LexiconManagement',
      component: LexiconManagement,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/TargetPhraseManagement',
      name: 'TargetPhraseManagement',
      component: TargetPhraseManagement,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/VoiceConfigs',
      name: 'VoiceConfigs',
      component: VoiceConfigs,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/VoiceConfigDetail',
      name: 'VoiceConfigDetail',
      component: VoiceConfigDetail,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/ValidationJobDetail',
      name: 'ValidationJobDetail',
      component: ValidationJobDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
        title: 'Q&A Validation Detail',
      },
    },
    {
      path: '/ValidationJobDetailV2',
      name: 'ValidationJobDetailV2',
      component: ValidationJobDetailV2,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
        title: 'Q&A Validation Detail V2',
      },
    },
    {
      path: '/ValidationMasterDataV2',
      name: 'ValidationMasterDataV2',
      component: ValidationMasterDataV2,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
        title: 'Validation Master Data',
      },
    },
    {
      path: '/ValidationTestRunnerV2',
      name: 'ValidationTestRunnerV2',
      component: ValidationTestRunnerV2,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
        title: 'Validation Test Run',
      },
    },
    {
      path: '/ValidationDashboardV2',
      name: 'ValidationDashboardV2',
      component: ValidationDashboardV2,
      meta: {
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
        title: 'Validation Dashboard',
      },
    },
    {
      path: '/ChatFullLogs',
      name: 'ChatFullLogs',
      component: ChatFullLogs,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/CifZeroInitLog',
      name: 'CifZeroInitLog',
      component: CifZeroInitLog,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxCategory',
      name: 'TaxCategory',
      component: TaxCategory,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxConfiguration',
      name: 'TaxConfiguration',
      component: TaxConfiguration,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxConfiguration/:taxYear/:versionCode',
      name: 'TaxConfigurationEdit',
      component: TaxConfigurationEdit,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxConfigurationV2',
      name: 'TaxConfigurationV2',
      component: TaxConfigurationV2,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxConfigurationV2/:taxYear/:versionCode',
      name: 'TaxConfigurationV2Edit',
      component: TaxConfigurationV2Edit,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxQuestionV2/:configVersionId/:questionVersionId',
      name: 'TaxQuestionV2Edit',
      component: TaxQuestionV2Edit,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxPlaygroundV2',
      name: 'TaxPlaygroundV2',
      component: TaxPlaygroundV2,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxFeedbackSettings',
      name: 'TaxFeedbackSettings',
      component: TaxFeedbackSettings,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxLogV2',
      name: 'TaxLogV2',
      component: TaxLogV2,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    // Offline viewer: opens a session JSON exported from the detail page. Same component as
    // TaxLogV2Detail — `meta.offline` is the switch that makes it read the file instead of the API.
    // Must stay BEFORE '/TaxLogV2/:sessionId' so the static path wins over the param.
    {
      path: '/TaxLogV2/offline',
      name: 'TaxLogV2Offline',
      component: TaxLogV2Detail,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
        offline: true,
      },
    },
    {
      path: '/TaxLogV2/:sessionId',
      name: 'TaxLogV2Detail',
      component: TaxLogV2Detail,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxChatLog',
      name: 'TaxChatLog',
      component: TaxChatLog,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxQuestion/:configVersionId/:questionVersionId',
      name: 'TaxQuestionEdit',
      component: TaxQuestionEdit,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      // Formula List — what "edit this Tax Calculate version" lands on. Route NAME stays
      // 'TaxCalculateEdit' (NavBar/links depend on it); the component is now the formula list.
      path: '/TaxCalculate/:configVersionId/:calcVersionId',
      name: 'TaxCalculateEdit',
      component: TaxCalculateList,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      // Formula — the Blockly canvas of ONE formula (drill-down from the list). `formulaId` = 'new'
      // creates one.
      path: '/TaxCalculate/:configVersionId/:calcVersionId/formula/:formulaId',
      name: 'TaxFormulaEdit',
      component: TaxFormulaBlockly,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      // Function List — the C# functions of ONE Tax Calculate V2 calc version.
      path: '/TaxCalculateV2/:configVersionId/:calcVersionId',
      name: 'TaxCalculateV2List',
      component: TaxCalculateV2List,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      // Function Editor — the C# source of ONE function (drill-down from the function list).
      path: '/TaxCalculateV2/:configVersionId/:calcVersionId/function/:functionId',
      name: 'TaxCalcFunctionV2Edit',
      component: TaxCalcFunctionV2Edit,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxSandbox',
      name: 'TaxSandbox',
      component: TaxSandbox,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxHistory',
      name: 'TaxHistory',
      component: TaxHistory,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxHistory/:formId',
      name: 'TaxHistoryDetail',
      component: TaxHistoryDetail,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxHistoryV2',
      name: 'TaxHistoryV2',
      component: TaxHistoryV2,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxHistoryV2/:formId',
      name: 'TaxHistoryV2Detail',
      component: TaxHistoryV2Detail,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxDashboard',
      name: 'TaxDashboard',
      component: TaxDashboard,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxConsent',
      name: 'TaxConsent',
      component: TaxConsent,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/TaxConsent/:versionCode',
      name: 'TaxConsentEdit',
      component: TaxConsentEdit,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: '/DecryptTax',
      name: 'DecryptTax',
      component: DecryptTax,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
  ],
});
// Permission arrays for each role
const SuperAdminRights = [
  'ToolManagement',
  'dashboard',
  'GPTModelManagement',
  'GPTModelDetail',
  'Vector',
  'LHBankConfig',
  'Replace',
  'Validation',
  'User',
  'ChatManagement',
  'Setting',
  'Report',
  'Logs',
  'VectorManagement',
  'MetaDoc',
  'UploadVector',
  'DocumentControl',
  'CommunityManagement',
  'CommunityGraph',
  'MetaCommunityManagement',
  'MetaCommunityGraph',
  'GenerationErrorLogs',
  'DataIntegration',
  'DataIntegrationDetail',
  'MutualFund',
  'MutualFundDetail',
  'ProductGroup',
  'ProductDetail',
  'UploadSoundToDocument',
  'UploadSoundToDocumentDetail',
  'FlowList',
  'FlowCreator',
  'FlowCompare',
  'IntentGroup',
  'IntentSession',
  'IntentSessionDetail',
  'AccountInfoManagement',
  'LoanInterestRate',
  'LHBDashboard',
  'ProactiveMessage',
  'BarManagement',
  'DeepLinkConfig',
  'MobileConfigurations',
  'TaxPlanningMobileConfigurations',
  'LexiconManagement',
  'TargetPhraseManagement',
  'VoiceConfigs',
  'VoiceConfigDetail',
  'GroupPromptTemplate',
  'PromptTemplate',
  'GroupReplacetext',
  'ReplaceText',
  'ValidationGenerate',
  'ValidationGenerateUpload',
  'ValidationProcess',
  'ValidationPositive',
  'ValidationPositiveDetail',
  'ValidationNegative',
  'ValidationNegativeDetail',
  'DashboardScore',
  'UserManagement',
  'UserChatManagement',
  'GroupUserManagement',
  'UserGroupDetail',
  'SetupUserGroup',
  'BlacklistChatUserManagement',
  'SetupGroupModel',
  'ModelShortcut',
  'ModelQuickReply',
  'ShortcutMenu',
  'Setup',
  'SettingExternalConnector',
  'McpConnection',
  'ModelData',
  'SetupSocial',
  'ServiceTheme',
  'ConsentConfig',
  'ReportQuestionTop10',
  'ReportUserTop10',
  'ReportUserUse',
  'ReportTokenSum',
  'ReportFeedback',
  'LogMessage',
  'ContactAgentChatLog',
  'LogEvent',
  'LogAPIExternal',
  'SocialApiLog',
  'JobLog',
  'Stream',
  'Playground',
  'CSharpPlayground',
  'ChatService',
  'Release-notes',
  'UserProfile',
  'FullStream',
  'Login',
  'AccessDenied',
  'ErrorPage',
  'ChatFullLogs',
  'CifZeroInitLog',
  'ValidationJobDetail',
  'ValidationJobDetailV2',
  'ValidationMasterDataV2',
  'ValidationTestRunnerV2',
  'ValidationDashboardV2',
  'TaxPlanning',
  'TaxCategory',
  'TaxConfiguration',
  'TaxConfigurationEdit',
  'TaxConfigurationV2',
  'TaxConfigurationV2Edit',
  'TaxQuestionV2Edit',
  'TaxPlaygroundV2',
  'TaxFeedbackSettings',
  'TaxLogV2',
  'TaxLogV2Detail',
  'TaxLogV2Offline',
  'TaxChatLog',
  'TaxHistoryV2',
  'TaxHistoryV2Detail',
  'TaxQuestionEdit',
  'TaxCalculateEdit',
  'TaxFormulaEdit',
  'TaxCalculateV2List',
  'TaxCalcFunctionV2Edit',
  'TaxSandbox',
  'TaxHistory',
  'TaxHistoryDetail',
  'TaxDashboard',
  'TaxConsent',
  'TaxConsentEdit',
  'DecryptTax'
];

const adminRights = [
  'ToolManagement',
  'dashboard',
  'GPTModelManagement',
  'GPTModelDetail',
  'Vector',
  'LHBankConfig',
  'Replace',
  'Validation',
  'User',
  'ChatManagement',
  'Setting',
  'Report',
  'Logs',
  'VectorManagement',
  'MetaDoc',
  'UploadVector',
  'DocumentControl',
  'CommunityManagement',
  'CommunityGraph',
  'MetaCommunityManagement',
  'MetaCommunityGraph',
  'GenerationErrorLogs',
  'DataIntegration',
  'DataIntegrationDetail',
  'MutualFund',
  'MutualFundDetail',
  'ProductGroup',
  'ProductDetail',
  'UploadSoundToDocument',
  'UploadSoundToDocumentDetail',
  'FlowList',
  'FlowCreator',
  'FlowCompare',
  'DocumentGroupManagement',
  'ProductGroupManagement',
  'IntentGroup',
  'IntentSession',
  'IntentSessionDetail',
  'AccountInfoManagement',
  'LoanInterestRate',
  'LHBDashboard',
  'ProactiveMessage',
  'BarManagement',
  'DeepLinkConfig',
  'MobileConfigurations',
  'TaxPlanningMobileConfigurations',
  'LexiconManagement',
  'TargetPhraseManagement',
  'VoiceConfigs',
  'VoiceConfigDetail',
  'GroupPromptTemplate',
  'PromptTemplate',
  'GroupReplacetext',
  'ReplaceText',
  'ValidationGenerate',
  'ValidationGenerateUpload',
  'ValidationProcess',
  'ValidationPositive',
  'ValidationPositiveDetail',
  'ValidationNegative',
  'ValidationNegativeDetail',
  'DashboardScore',
  'UserManagement',
  'UserChatManagement',
  'GroupUserManagement',
  'UserGroupDetail',
  'SetupUserGroup',
  'BlacklistChatUserManagement',
  'SetupGroupModel',
  'ModelShortcut',
  'ModelQuickReply',
  'ShortcutMenu',
  'Setup',
  'SettingExternalConnector',
  'McpConnection',
  'ModelData',
  'SetupSocial',
  'ServiceTheme',
  'ConsentConfig',
  'ReportQuestionTop10',
  'ReportUserTop10',
  'ReportUserUse',
  'ReportTokenSum',
  'ReportFeedback',
  'LogMessage',
  'ContactAgentChatLog',
  'LogEvent',
  'LogAPIExternal',
  'ChatService',
  'Release-notes',
  'UserProfile',
  'Stream',
  'Playground',
  'CSharpPlayground',
  'FullStream',
  'Login',
  'AccessDenied',
  'ErrorPage',
  'ChatFullLogs',
  'CifZeroInitLog',
  'ValidationJobDetail',
  'ValidationJobDetailV2',
  'ValidationMasterDataV2',
  'ValidationTestRunnerV2',
  'ValidationDashboardV2',
  'TaxPlanning',
  'TaxCategory',
  'TaxConfiguration',
  'TaxConfigurationEdit',
  'TaxConfigurationV2',
  'TaxConfigurationV2Edit',
  'TaxQuestionV2Edit',
  'TaxPlaygroundV2',
  'TaxFeedbackSettings',
  'TaxLogV2',
  'TaxLogV2Detail',
  'TaxLogV2Offline',
  'TaxChatLog',
  'TaxHistoryV2',
  'TaxHistoryV2Detail',
  'TaxQuestionEdit',
  'TaxCalculateEdit',
  'TaxFormulaEdit',
  'TaxCalculateV2List',
  'TaxCalcFunctionV2Edit',
  'TaxSandbox',
  'TaxHistory',
  'TaxHistoryDetail',
  'TaxDashboard',
  'TaxConsent',
  'TaxConsentEdit',
  'DecryptTax'
];

const generalUsersRights = [
  'dashboard',
  'Vector',
  'LHBankConfig',
  'VectorManagement',
  'MetaDoc',
  'UploadVector',
  'DocumentControl',
  'DataIntegration',
  'DataIntegrationDetail',
  'MutualFund',
  'MutualFundDetail',
  'AccountInfoManagement',
  'LoanInterestRate',
  'ProactiveMessage',
  'BarManagement',
  'Release-notes',
  'UserProfile',
  'FullStream',
  'Login',
  'AccessDenied',
  'ErrorPage',
  'UploadSoundToDocument',
  'UploadSoundToDocumentDetail',
  'ProductGroup',
  'ProductDetail',
  'CommunityManagement',
  'CommunityGraph',
  'MetaCommunityManagement',
  'MetaCommunityGraph',
  'GenerationErrorLogs',
];

const operatorRights = ['dashboard', 'ChatService', 'Release-notes', 'UserProfile', 'FullStream', 'Login', 'AccessDenied', 'ErrorPage', 'ChatFullLogs', 'CifZeroInitLog'];

// Function to check if user has permission to access route
function hasPermission(routeName, roleId) {
  // Public routes that don't require permission check
  const publicRoutes = ['Login', 'LoginSnippet', 'Snippet', 'RedirectFromLogin', 'AccessDenied', 'ErrorPage', 'FullStream'];
  if (publicRoutes.includes(routeName)) {
    return true;
  }

  // Always-allowed routes
  const alwaysAllowed = ['UserProfile', 'Release-notes'];
  if (alwaysAllowed.includes(routeName)) {
    return true;
  }

  // Custom Page Permission check — list now contains { key, mode } (mode = 'view' | 'edit').
  // Both modes grant route access; individual pages handle view-only restrictions themselves.
  const isCustom = Cookies.get('isCustomPageAccess') === 'true';
  if (isCustom) {
    try {
      const raw = JSON.parse(localStorage.getItem('customPagePermission') || '[]');
      const allowedKeys = Array.isArray(raw)
        ? raw.map((e) => (typeof e === 'string' ? e : e && e.key)).filter(Boolean)
        : [];
      return allowedKeys.includes(routeName) || isChildRouteAllowed(routeName, allowedKeys);
    } catch {
      return false;
    }
  }

  // Default role-based check
  let allowedRoutes = [];
  if (roleId == '0' || roleId == 0) {
    allowedRoutes = SuperAdminRights;
  } else if (roleId == '1' || roleId == 1) {
    allowedRoutes = adminRights;
  } else if (roleId == '2' || roleId == 2) {
    allowedRoutes = generalUsersRights;
  } else {
    allowedRoutes = operatorRights;
  }

  return allowedRoutes.includes(routeName);
}

// Map child/detail routes to parent key — ใช้ร่วมกันระหว่างการตรวจสิทธิ์แบบ custom page
// และการตรวจเมนูที่ถูกปิดตาม menuClosure config (ดู isRouteClosed)
// ตารางอยู่ที่ utils/pagePermission.js ชุดเดียว เพื่อไม่ให้สองที่เพี้ยนออกจากกัน
const childToParent = CHILD_TO_PARENT;

// Helper: map child/detail routes to parent key for custom permission
function isChildRouteAllowed(routeName, allowedPages) {
  const parentKey = childToParent[routeName];
  return parentKey ? allowedPages.includes(parentKey) : false;
}

/**
 * route นี้ถูกปิดตาม menuClosure config หรือไม่
 *
 * ไล่ขึ้นตามสาย childToParent ด้วย เพื่อครอบ route ลูกที่ไม่ได้อยู่ใน navbar
 * จึงไม่มีในเอกสาร 47 รายการ เช่น TaxSandbox / TaxConfigurationEdit ซึ่งเป็นลูก
 * ของ TaxPlanning ที่ถูกปิด — ถ้าไม่ไล่สาย จะยังเปิด URL ตรงเข้าไปได้
 *
 * ยกเว้นหน้าที่อยู่ใน CLOSURE_EXEMPT_KEYS ซึ่งไม่ได้ถูก Mark ปิดในเอกสาร แต่บังเอิญ
 * มีแม่อยู่ในสายที่ถูกปิด เช่น 'DocumentControl' (ลูกของ 'VectorManagement')
 * ที่ยังต้องเข้าได้จากปุ่ม Manage Knowledge ในหน้า MetaDoc
 */
function isRouteClosed(routeName) {
  if (isClosureExempt(routeName)) return false;

  let key = routeName;
  const visited = new Set();
  while (key && !visited.has(key)) {
    if (isMenuClosed(key)) return true;
    visited.add(key);
    key = childToParent[key];
  }
  return false;
}

router.beforeEach((to, from, next) => {
  // ด่านแรก: เมนูที่ถูกปิดตาม menuClosure config เข้าไม่ได้ทุกกรณี
  // ต้องอยู่ก่อนสาขา requiresAuth เพราะ hasPermission() จะถูกเรียกเฉพาะ route
  // ที่มี meta.requiresAuth เท่านั้น และการตรวจตรงนี้ครอบสิทธิ์แบบ custom page
  // (isCustomPageAccess) ซึ่ง bypass rights array ไปด้วย
  if (isRouteClosed(to.name)) {
    next({ name: 'AccessDenied' });
    return;
  }

  // Check if route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if user is authenticated
    if (Cookies.get('authenticated')) {
      const roleId = Cookies.get('roleId');
      const routeName = to.name;

      // Check if user has permission to access this route
      if (hasPermission(routeName, roleId)) {
        next();
      } else {
        next({ name: 'AccessDenied' });
      }
      return;
    }
    // Not authenticated, redirect to login
    next('/login');
  } else {
    // Route doesn't require auth
    next();
  }
});

export default router;
